<div class="container">
  <h2>Adjust Cover Image</h2>
  
  <!-- File input for image upload -->
  <input 
    type="file" 
    accept="image/*" 
    (change)="fileChangeEvent($event)" 
    class="file-input" 
  />

  <!-- Image cropper -->
  <div *ngIf="showCropper" class="cropper-container">
    <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      [aspectRatio]="2.7 / 1"
      [resizeToWidth]="820"
      format="jpeg"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  </div>

  <!-- Preview of cropped image -->
  <div *ngIf="croppedImage" class="preview-container">
    <h3>Preview</h3>
    <img [src]="croppedImage" alt="Cropped Image" class="preview-image" />
  </div>

  <!-- Save button -->
  <button 
    *ngIf="croppedImage" 
    (click)="saveCroppedImage()" 
    class="save-button"
  >
    Save Cover Image
  </button>
</div>